export const formatPrice = (num: number): string => {
  if(!Number.isFinite(num)) return '￥-'
  return num.toLocaleString('ja-JP', {style: 'currency', currency: 'JPY'})
}